import { useContext, createContext } from 'react';

import type { IEmitentsDetailPageDataContext } from './models';

export const EmitentsDetailPageDataContext = createContext<IEmitentsDetailPageDataContext>({
    asset: null,
    decomposedRating: null,
    originPathnameUri: '',
    masterOriginPathnameUri: '',
});
export const useEmitentsDetailPageDataContext = () => useContext(EmitentsDetailPageDataContext);
